module.exports = __webpack_public_path__ + "img/KIWA-LOGO-white.182baa89.png";